import styled from '@emotion/styled'

export const ValueWrapper = styled.div`
  min-width: 0;
  word-break: break-word;
`
